<template>
	<div class="bulletinbox">

		<div class="peripheral">
			<largemarket @retquery="retquery"></largemarket>
		</div>

		<div class="peripheral" v-loading="load_chart">
			<bullehead title="数据曲线"></bullehead>
			<div class="chart_absolute">
				<dataEchart ref="dataEch" :dataobj="line_chart"></dataEchart>
			</div>
		</div>


		<div class="cake_box FlexBetween" v-loading="load_chart">
			<div class="cake_item">
				<sharetybox :dataobj="share_data"></sharetybox>
			</div>
			<div class="cake_item onRight">
				<sharetybox :types="2" :dataobj="share_data"></sharetybox>
			</div>
		</div>

		<div class="peripheral" v-loading="load_chart">
			<bullehead title="访问时间段"></bullehead>
			<div class="chart_absolute h338">
				<visitEchart ref="visitEch" :dataobj="column_chart"></visitEchart>
			</div>
		</div>


		<div class="cake_box FlexBetween" v-loading="load_chart">
			<div class="cake_item ">
				<bullehead title="访问类型"></bullehead>
				<div class="chart_absolute h314 paddRig">
					<caketyeEchart ref="caketyeEch" :dataobj="pie_chart"></caketyeEchart>
				</div>


			</div>
			<div class="cake_item onRight ">
				<bullehead title="访问时长"></bullehead>
				<div class="chart_absolute h314 paddRig">
					<caketieEchart ref="caketieEch" :dataobj="pie_chart"></caketieEchart>
				</div>

			</div>
		</div>

		<div class="cake_box FlexBetween" v-loading="load_chart">
			<div class="cake_item " :class="{'onRight': index == 2}" v-for="(item, index) in 3">
				<ranklist :types="index + 1" :dataobj="bangdan_data"></ranklist>
			</div>
		</div>

		<div class="cake_box FlexBetween" v-loading="load_chart">
			<div class="cake_item" :class="{'onRight': index == 2}" v-for="(item, index) in 3">
				<ranklist :types="index + 4" :dataobj="bangdan_data"></ranklist>
			</div>
		</div>





	</div>
</template>

<script>
	import bullehead from "./components/bullehead.vue"
	import largemarket from "./components/largemarket.vue"
	import dataEchart from "./components/dataEchart.vue"
	import sharetybox from "./components/sharetybox.vue"
	import visitEchart from "./components/visitEchart.vue"
	import caketyeEchart from "./components/caketyeEchart.vue"
	import caketieEchart from "./components/caketieEchart.vue"
	import ranklist from "./components/ranklist.vue"
	import {
		get_customer_kanban_data,
		get_customer_kanban_share,
		get_customer_kanban_list,
		getThisYear,
	} from "./js/billet.js"
	export default {
		name: 'bulletinboard',
		components: {
			bullehead,
			largemarket,
			dataEchart,
			sharetybox,
			visitEchart,
			caketyeEchart,
			caketieEchart,
			ranklist,
		},
		data() {
			return {
				currMember_id: '',
				currTime: '',
				line_chart: {},
				column_chart: {},
				pie_chart: {},
				share_data: {},
				bangdan_data: {},
				load_chart: true,
			}
		},
		created() {
			this.getdatalist()
			this.currTime = getThisYear()
		},
		mounted() {
			var that = this
			setTimeout(() => {
				window.onresize = () => {
					that.fn_mountEch()
				}
			}, 300);
		},
		beforeDestroy() {
			window.onresize = null;
		},
		methods: {
			// 分享
			getsharelist(data) {
				get_customer_kanban_share(data).then(res => {
					if (!res) return
					let obj = res.result
					this.share_data = obj

				})
			},
			// 榜单
			getbangdanlist(data) {
				get_customer_kanban_list(data).then(res => {
					if (!res) return
					let obj = res.result
					this.bangdan_data = obj

				})
			},
			// 4个图表
			getdatalist() {
				this.load_chart = true
				let data = {
					member_id: this.currMember_id, //	否	int	成员id
				}
				data.search_time = this.currTime ? this.currTime : getThisYear()
				get_customer_kanban_data(data).then(res => {
					if (!res) return
					let obj = res.result
					this.line_chart = obj.line_chart || {}
					this.column_chart = obj.column_chart || {}
					this.pie_chart = obj.pie_chart || {}
					this.load_chart = false
				})
				this.getsharelist(data)
				this.getbangdanlist(data)
			},

			retquery(res) {
				let {
					member_id,
					time
				} = res
				this.currMember_id = member_id ? member_id * 1 : '';
				this.currTime = time
				this.getdatalist()
			},

			fn_mountEch() {
				if (this.$refs.dataEch) {
					this.$refs.dataEch.myChart1.resize()
				}
				if (this.$refs.visitEch) {
					this.$refs.visitEch.myChart2.resize()
				}
				if (this.$refs.caketyeEch) {
					this.$refs.caketyeEch.myChart.resize()
				}
				if (this.$refs.caketieEch) {
					this.$refs.caketieEch.myChart.resize()
				}

			},

		}
	}
</script>

<style lang="scss" scoped>
	@import "./css/billet.scss";

	.bulletinbox {
		min-width: 960px;
	}

	.peripheral {
		width: 100%;
		border-radius: 5px;
		overflow: hidden;
		min-width: 960px;
		margin-bottom: 10px;

	}

	.chart_absolute.h338 {
		height: 338px;
	}

	.chart_absolute.h314 {
		height: 314px;
	}

	.chart_absolute {
		width: 100%;
		position: relative;
		height: 379px;
	}

	.chart_absolute.paddRig {
		padding-right: 20px;

	}

	.cake_box {
		width: 100%;
		margin-bottom: 10px;

		.cake_item {
			position: relative;
			border-radius: 5px;
			overflow: hidden;
			background-color: #fff;
			flex: 1;
			margin-right: 10px;
		}
	}
</style>